<template>
  <div class="app-container ranking-list">
    <div class="ranking-list-filter">
      <el-row :gutter="10">
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <el-select 
              ref="rankingTargetTypeSelect" 
              v-model="search.rankingTarget"
              @keyup.enter.native="searchChange" 
              @keydown.enter.native="$refs.rankingTargetTypeSelect.visible = false" 
              placeholder="参与范围"
              clearable
              size="small">
              <el-option
                v-for="(item, index) in rankingTargetTypes"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <el-select 
              ref="rankingTypeSelect" 
              v-model="search.rankingType" 
              @keyup.enter.native="searchChange" 
              @keydown.enter.native="$refs.rankingTypeSelect.visible = false" 
              placeholder="排行榜规则"
              clearable 
              size="small">
              <el-option
                v-for="(item, index) in rankingTypes"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <el-select 
              ref="rankingPeroidTypeSelect" 
              v-model="search.rankingPeriod"
              @keyup.enter.native="searchChange" 
              @keydown.enter.native="$refs.rankingPeroidTypeSelect.visible = false" 
              placeholder="周期"
              clearable 
              size="small">
              <el-option
                v-for="(item, index) in rankingPeroidTypes"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <el-button class="ranking-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="ranking-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class = "ranking-list-container">
      <avue-crud ref="crud"
                 :option="tableOption"
                 :data="tableData"
                 :page="page"
                 :table-loading="tableLoading"
                 @current-change="handleCurrentChange"
                 @size-change="handleSizeChange">

        <template slot-scope="scope" slot="menu">
          <el-row>
            <el-button type="text" v-if="permissions.ranking_view" icon="el-icon-view" size="mini" @click="handleView(scope.row,scope.index)">查看详情</el-button>
          </el-row>
        </template>

      </avue-crud>
    </basic-container>

  </div>
</template>

<script>
  import {fetchRankingList} from '@/api/analysis/rankingAnalysis'
  import {tableOption, rankingTypes, rankingTargetTypes, rankingPeroidTypes} from '@/const/crud/analysis/rankingAnalysis'
  import {mapGetters} from "vuex"
  import { formatDate } from '@/util/date'

  export default {
    data () {
      return {
        search: {
          current: 1,
          size: 10,
          rankingType: undefined,
          rankingTarget: undefined,
          rankingPeriod: undefined,
        },
        tableData:[],
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        tableOption,
        rankingTypes,
        rankingTargetTypes,
        rankingPeroidTypes,
        tableLoading: false,
      }
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    async created() {
      this.getRankingList()
    },
    methods: {
      getRankingList() {
        let params = {
          current: this.search.current,
          size: this.search.size,
          rankingType: this.search.rankingType,
          rankingTarget: this.search.rankingTarget,
          rankingPeriod: this.search.rankingPeriod
        }
        this.tableLoading = true
        fetchRankingList(params).then(response => {
          this.tableData = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.tableLoading = false
        });
      },
      formatData(records) {
        let tempTableDatas=[]
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            let tempTableData ={}
            tempTableData.id = record.id
            tempTableData.rankingTitle = record.rankingTitle
            tempTableData.rankingType = rankingTypes.find(item => item.value === record.rankingType).label
            tempTableData.rankingTarget = rankingTargetTypes.find(item => item.value === record.rankingTarget).label
            tempTableData.rankingPeriod = rankingPeroidTypes.find(item => item.value === record.rankingPeriod).label
            tempTableData.rankingDateInterval = formatDate('YYYY-mm-dd', new Date(record.rankingStartDate)) + ' 至 ' + formatDate('YYYY-mm-dd', new Date(record.rankingEndDate))
            tempTableDatas.push(tempTableData)
          })
        }
        return tempTableDatas
      },
      handleView(row) {
        if (row.id){
          this.$router.push({
            path: `/analysis/ranking/detail`,
            query: {
              id: row.id,
              type: row.rankingType,
              target: row.rankingTarget
            }
          })
        } else {
          this.$message({
            showClose: true,
            message: '该排行榜不存在',
            type: 'warning'
          })
        }
      },
      searchChange() {
        this.getRankingList()
      },
      searchReset() {
        this.search.rankingType = undefined
        this.search.rankingTarget = undefined
        this.search.rankingPeriod = undefined
        this.searchChange()
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getRankingList()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.search.size = val
        this.getRankingList()
      },
    }
  }
</script>

<style  lang="scss" scoped>

.ranking-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}


</style>